import React, { useRef } from 'react';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import PropTypes from 'prop-types';
import Tooltip from 'cccisd-tooltip';
import notification from 'cccisd-notification';
import confirm from 'cccisd-confirm';
import StudentForm from 'js/components/StudentForm';
import IconPencil from 'cccisd-icons/pencil';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const EditStudentForm = props => {
    const modal = useRef();

    // rows are coming from uberadmin's learner_tableMain.graphql
    const { row, loadData } = props;

    const updateStudent = async values => {
        const response = await axios.put(
            Boilerplate.route('api.nexus.pawn.update', {
                pawn: row['pawn.pawnId'],
            }),
            {
                pawnHash: row['pawn.pawnHash'],
                studentId: values.studentId,
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                phone: values.phone,
                parentPawns: values.parentPawns[0],
                state: values.state,
                district: values.district,
                group: values.site[0],
                role: 'learner',
            }
        );
        if (response.data.errors) {
            return Promise.reject(response.data.errors);
        }
        await loadData();
        notification('Student edited.');
        await modal.current.close();
    };

    const onSubmit = async values => {
        if (row['parentRoles.instructor.pawn.pawnId'] !== values.parentPawns[0]) {
            // if the instructor has changed, we need to get confirmation of this change
            // in case it affects assignment plans
            confirm({
                message: 'Provider is changing.  Are you sure?',
                description:
                    'Any assignment plans for the student will be copied to the new provider and continue to be assigned to the student. Please confirm you want the provider to change.',
                confirmLabel: 'Confirm',
                abortLabel: 'Cancel',
            })
                .then(async () => {
                    updateStudent(values);
                })
                .fail(() => {});
        } else {
            updateStudent(values);
        }
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <Tooltip title="Edit Student">
                    <button type="button" className="btn btn-xs btn-success">
                        <IconPencil />
                    </button>
                </Tooltip>
            }
            title={row['fields.studentId'] ? `Edit ${row['fields.studentId']}` : `Edit Student`}
        >
            <StudentForm
                onSubmit={onSubmit}
                initialValues={{
                    studentId: row['fields.studentId'],
                    firstName: row['fields.firstName'],
                    lastName: row['fields.lastName'],
                    email: row['fields.email'],
                    phone: row['fields.phone'],
                    state: [row['ancestorGroups.organization.group.groupId']],
                    district: [row['ancestorGroups.groupingUnit.group.groupId']],
                    site: [row['ancestorGroups.site.group.groupId']],
                    instructor: [row['parentRoles.instructor.pawn.pawnId']],
                }}
                {...props}
            />
        </Modal>
    );
};

EditStudentForm.propTypes = {
    loadData: PropTypes.func,
    row: PropTypes.object,
};

export default EditStudentForm;
